import { useWatch } from 'react-hook-form';
import { useFormValidation } from 'domains/form-validation';

/**
 * Watches a form field for changes, but uses the yup schema to cast
 * the resulting value.
 *
 * @ref https://react-hook-form.com/api/usewatch/
 * @ref https://github.com/jquense/yup#schemacastvalue-any-options---infertypeschema
 *
 * @param name the name of the field to watch
 * @returns the casted value based on the field's current value and the schema or undefined
 */
export const useWatchCasted = <T>(name: string): T | undefined => {
  const { schema } = useFormValidation();
  const currentValue = useWatch({ name });

  return schema?.fields[name].cast(currentValue, { assert: false });
};
